export const getGdprConsents = ({ gdpr: { consents } }) => consents;
